import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
} from "@mui/material";

import { Controller, useForm } from "react-hook-form";

import { useSuperAdminOrganization } from "../../../context/SuperAdmin/OrganizationContext";
import { PostOrgFields } from "../../../interfaces/SuperAdmin/Pages/iDataOrganizacion";
import { environment } from "../../../config";

const CreateOrgModal = () => {
  const {
    isCreateModalOpen,
    toggleCreateModal,
    isCreating,
    paises,
    tiposPlan,
    tiposObjetivo,
    isLoadingPaises,
    submitOrganizacion,
  } = useSuperAdminOrganization();

  const { VERSION } = environment;

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm<PostOrgFields>({});

  // Función para manejar el envío del formulario
  const handleSubmitForm = (data: PostOrgFields) => {
    const newData: PostOrgFields = {
      ...data,
      version: VERSION as string
    };
    console.log(newData);

    submitOrganizacion(newData);
    reset();
    // Aquí puedes hacer la petición a la API
  };

  const handleClose = () => {
    if (!isCreating) {
      reset();
      toggleCreateModal(false);
    }
  };

  return (
    <Modal
      open={isCreateModalOpen}
      onClose={handleClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "rgba(0, 0, 0, 0.3)", // Fondo negro con opacidad
      }}
    >
      <Box
        component="form"
        sx={{
          width: 400,
          bgcolor: "background.paper",
          borderRadius: 2,
          p: 4,
          boxShadow: 24,
          minWidth: "600px",
          display: "flex",
          flexDirection: "column",
          gap: 3,
        }}
        onSubmit={handleSubmit(handleSubmitForm)}
      >
        {isLoadingPaises ? (
          <Typography
            id="edit-subscription-modal-title"
            justifyContent={"center"}
            sx={{
              width: 1,
              textAlign: "center",
              fontSize: "20px",
              fontWeight: 500,
            }}
          >
            Cargando...
          </Typography>
        ) : (
          <>
            <Typography variant="h6" component="h2">
              Nueva organizacion
            </Typography>

            {/* Campo Nombre */}
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                Nombre de la organización
              </Typography>
              <Controller
                name="nombre"
                control={control}
                rules={{ required: "El nombre es obligatorio" }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    margin="normal"
                    error={!!errors.nombre}
                    helperText={errors.nombre?.message}
                    disabled={isCreating}
                  />
                )}
              />
            </Box>

            {/* Campo Pais */}
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                País
              </Typography>
              <FormControl error={!!errors.id_pais}>
                <Controller
                  name="id_pais"
                  control={control}
                  rules={{ required: "El país es obligatorio" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      value={field.value || ""}
                      fullWidth
                      disabled={isCreating}
                    >
                      {paises.map((pais) => (
                        <MenuItem key={pais.id_pais} value={pais.id_pais}>
                          {pais.nombre}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                />
                <FormHelperText>{errors.id_pais?.message}</FormHelperText>
              </FormControl>
            </Box>

            {/* Campo Tipo plan */}
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                Tipo de plan
              </Typography>
              <FormControl error={!!errors.id_tipo_plan}>
                <Controller
                  name="id_tipo_plan"
                  control={control}
                  rules={{ required: "El tipo de plan es obligatorio" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      value={field.value || ""}
                      fullWidth
                      disabled={isCreating}
                    >
                      {tiposPlan.map((plan) => (
                        <MenuItem
                          key={plan.id_tipo_plan}
                          value={plan.id_tipo_plan}
                        >
                          {plan.nombre}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                />
                <FormHelperText>{errors.id_tipo_plan?.message}</FormHelperText>
              </FormControl>
            </Box>

            {/* Campo Tipos de OAS */}
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                Tipos de OAS
              </Typography>
              <FormControl error={!!errors.tipo_objetivo}>
                <Controller
                  name="tipo_objetivo"
                  control={control}
                  rules={{ required: "Debes seleccionar al menos un tipo de OAS" }}
                  render={({ field }) => (
                    <FormGroup>
                      {tiposObjetivo.map((tipo) => (
                        <FormControlLabel
                          key={tipo.id_tipo_objetivo}
                          control={
                            <Checkbox
                              checked={field.value?.includes(tipo.id_tipo_objetivo) || false}
                              onChange={(e) => {
                                const newValue = e.target.checked
                                  ? [...(field.value || []), tipo.id_tipo_objetivo]
                                  : (field.value || []).filter((v: string) => v !== tipo.id_tipo_objetivo);
                                field.onChange(newValue);
                              }}
                              disabled={isCreating}
                            />
                          }
                          label={tipo.nombre}
                        />
                      ))}
                    </FormGroup>
                  )}
                />
                <FormHelperText>{errors.tipo_objetivo?.message}</FormHelperText>
              </FormControl>
            </Box>

            <Box sx={{ mt: 3, textAlign: "right" }}>
              <Button
                variant="contained"
                sx={{ background: "#336B87" }}
                disabled={isCreating}
                type="submit"
              >
                Crear
              </Button>
            </Box>
          </>
        )}
      </Box>
    </Modal>
  );
};

export default CreateOrgModal;
